import { useMemo } from 'react';
import type { InvestmentResult } from '@brimo/shared';
import type { CalculatorContext, InvestmentInputValues } from '../types';
import { FactsSections } from './advisor/FactsSections';
import { UnitSection } from './advisor/UnitSection';
import { YearSections } from './advisor/YearSections';
import { advisorDisclaimer, advisorPurchaseYear } from './model';
import styles from './advisor.module.css';

export interface AdvisorTabProps {
  context: CalculatorContext;
  values: InvestmentInputValues;
  /** `calculateInvestment(values)` of the page (the customer view's `result`). */
  result: InvestmentResult;
  /** Copies Nico's text summary (`buildTextSummary`, D-350). */
  onCopySummary: () => void;
}

/**
 * „Berateransicht": the advisor shows it to the customer on screen. Sections after the DokuMe calculator in the
 * DAMOKLES design (owner decision Paul 02.11.2026, D-386…D-392); every figure comes from the live inputs.
 */
export function AdvisorTab({ context, values, result, onCopySummary }: AdvisorTabProps) {
  const purchaseYear = useMemo(() => advisorPurchaseYear(), []);
  return (
    <div className={styles.root}>
      <UnitSection context={context} values={values} result={result} />
      <FactsSections context={context} values={values} result={result} purchaseYear={purchaseYear} />
      <YearSections
        result={result}
        purchasePriceCents={values.purchasePriceCents}
        purchaseYear={purchaseYear}
        onCopySummary={onCopySummary}
      />
      <p className={styles.disclaimer}>{advisorDisclaimer(values)}</p>
    </div>
  );
}
